import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["offsetTop", "offsetBottom", "horizontal", "container", "target", "onChange", "onTargetChange", "zIndex", "canHidden", "childrenRef"];
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { addEventListener, removeEventListener } from './utils';
import { prefix } from "../../wui-core/src/index.js";
var propTypes = {
  container: PropTypes.object,
  offsetTop: PropTypes.number,

  /** 距离窗口顶部达到指定偏移量后触发 */
  offsetBottom: PropTypes.number,

  /** 距离窗口底部达到指定偏移量后触发 */
  horizontal: PropTypes.bool,
  target: PropTypes.func,
  //不对外开放，获取滚动scroll以及resize功能
  onChange: PropTypes.func,
  //状态fixed或infixed时候调用
  onTargetChange: PropTypes.func,
  //功能只有一个，时时刻刻输出state的状态
  zIndex: PropTypes.number,
  canHidden: PropTypes.bool,
  childrenRef: PropTypes.object
};
var defaultProps = {
  horizontal: false,
  // container: document.body,
  target: function target() {
    return window;
  },
  onChange: function onChange(affixed) {
    return {};
  },
  onTargetChange: function onTargetChange(state) {
    return {};
  },
  zIndex: 2019,
  canHidden: false,
  childrenRef: null
};

var Affix = /*#__PURE__*/function (_Component) {
  _inherits(Affix, _Component);

  var _super = _createSuper(Affix);

  function Affix(props) {
    var _this;

    _classCallCheck(this, Affix);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getContainerDOM", function (nextProps) {
      var container = nextProps ? nextProps.container : _this.props.container;

      if (!container) {
        return document.body;
      }

      if (container != document.body) {
        return ReactDOM.findDOMNode(container);
      }

      return container;
    });

    _defineProperty(_assertThisInitialized(_this), "getInitPosition", function (nextProps, flag) {
      var container = _this.getContainerDOM(nextProps); // 20180927children是个变化，所以在nextprops要传入childrenRef，否则直接使用后面的语句


      var thisElm = nextProps && nextProps.childrenRef && ReactDOM.findDOMNode(nextProps.childrenRef) || ReactDOM.findDOMNode(_assertThisInitialized(_this));

      _this.setState({
        height: thisElm.offsetHeight,
        width: thisElm.offsetWidth,
        containerHeight: container.offsetHeight,
        containerWidth: container.offsetWidth
      });

      var containerRect = container.getBoundingClientRect();
      var thisElemRect = thisElm.getBoundingClientRect();
      var top = thisElemRect.top,
          left = thisElemRect.left,
          bottom = thisElemRect.bottom;
      var marginTop = top - containerRect.top;
      var marginLeft = left - containerRect.left;
      var marginBottom = containerRect.bottom - bottom; //距离底部距离

      _this.setState({
        top: top,
        left: left,
        initTop: flag ? top : _this.state.initTop,
        initBottom: flag ? bottom : _this.state.initBottom,
        initLeft: flag ? left : _this.state.initLeft,
        marginTop: marginTop,
        marginBottom: marginBottom,
        marginLeft: marginLeft
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTargetChange", function (evt, type) {
      var container = _this.getContainerDOM(); //是body


      var _container$getBoundin = container.getBoundingClientRect(),
          top = _container$getBoundin.top,
          left = _container$getBoundin.left,
          bottom = _container$getBoundin.bottom;

      _this.setState({
        top: top + _this.state.marginTop,
        //=0是临界值，滚动条使得屏幕顶端正好在affix上面，前者一直变化后者为不变
        left: left + _this.state.marginLeft,
        //原理同上
        bottom: window.innerHeight - bottom + _this.state.marginBottom,
        //原理同上
        containerHeight: container.offsetHeight,
        containerWidth: container.offsetWidth
      });

      if (_this.offsetTopCp !== undefined && _this.state.top < _this.offsetTopCp || _this.props.offsetBottom !== undefined && _this.state.bottom > _this.props.offsetBottom) {
        if (_this.state.affixed === false) {
          _this.props.onChange({
            affixed: true,
            event: evt
          });
        }

        _this.setState({
          affixed: true
        }); //=true,calculate起作用

      }

      if (_this.offsetTopCp !== undefined && _this.state.top >= _this.offsetTopCp || _this.props.offsetBottom !== undefined && _this.state.bottom <= _this.props.offsetBottom) {
        if (_this.state.affixed === true) {
          _this.props.onChange({
            affixed: false,
            event: evt
          }); //新增还原样式

        }

        _this.setState({
          affixed: false
        });
      }

      _this.props.onTargetChange(_this.state);

      _this.getInitPosition(undefined, false);
    });

    _defineProperty(_assertThisInitialized(_this), "calculate", function () {
      var fixStyle = {};
      var boxStyle = {}; //20171102修改，添加(this.state.top - this.state.marginTop == 0)的判断，谨防height+offsetTop >= containerHeight, handleTargetChange中的
      //this.state.top <= this.props.offsetTop 恒成立，一直有position:affixed

      if (!_this.state.affixed || _this.offsetTopCp !== undefined && _this.state.top - _this.state.marginTop == 0) return {
        fixStyle: fixStyle,
        boxStyle: boxStyle
      };
      var h = _this.state.top - _this.state.marginTop + _this.state.containerHeight - _this.state.height;

      if (_this.offsetTopCp !== undefined && _this.state.top < _this.offsetTopCp) {
        fixStyle = {
          position: "fixed",
          //修改20171102 去掉展示Affix全部内容，若是Affix内容高度大于container可展示，那么Affix只可展示部分
          // top: this.props.canHidden ? ( h < 0 ? h : Math.min(h, this.props.offsetTop)) : ( h < 0 ? 0 : Math.min(h, this.props.offsetTop)),
          top: _this.props.canHidden ? h < 0 ? h : Math.min(h, _this.offsetTopCp) : _this.offsetTopCp,
          left: _this.props.horizontal ? _this.state.initLeft : _this.state.left,
          height: _this.state.height,
          width: _this.state.width,
          zIndex: _this.props.zIndex
        };
        boxStyle = {
          height: _this.state.height
        };
      } else if (_this.props.offsetBottom !== undefined && _this.state.bottom > _this.props.offsetBottom) {
        fixStyle = {
          position: "fixed",
          //修改20171102 去掉展示Affix全部内容，若是Affix内容高度大于container可展示，那么Affix只可展示部分
          // top: this.props.canHidden ? ( h < 0 ? h : Math.min(h, this.props.offsetTop)) : ( h < 0 ? 0 : Math.min(h, this.props.offsetTop)),
          bottom: _this.props.canHidden ? h < 0 ? h : Math.min(h, _this.props.offsetBottom) : _this.props.offsetBottom,
          left: _this.props.horizontal ? _this.state.initLeft : _this.state.left,
          height: _this.state.height,
          width: _this.state.width,
          zIndex: _this.props.zIndex
        };
        boxStyle = {
          height: _this.state.height
        };
      }

      return {
        fixStyle: fixStyle,
        boxStyle: boxStyle
      };
    });

    _this.state = {
      affixed: false,
      initTop: 0,
      initBottom: 0,
      initLeft: 0,
      top: 0,
      //affix距离顶部的距离
      left: 0,
      //affix距离左边的距离
      bottom: 0,
      //affix距离底部的距离
      marginTop: 0,
      //top - containerTop
      marginBottom: 0,
      //bottom - containerBottom
      marginLeft: 0,
      //left - containerLeft
      height: 0,
      //affix的高度
      width: 0,
      //affix的宽度
      containerHeight: 0,
      //container的高度
      containerWidth: 0,
      //container的宽度
      containerId: "".concat(prefix, "-affix-container") + Math.random().toString(26).substring(2, 10)
    }; // offsetTop默认值设置，如果没有offsetBottom和offsetTop属性，offsetTop默认值设置为0

    _this.offsetTopCp = props.hasOwnProperty('offsetBottom') ? undefined : props.hasOwnProperty('offsetTop') ? props.offsetTop : 0;
    _this.calculate = _this.calculate.bind(_assertThisInitialized(_this));
    _this.getInitPosition = _this.getInitPosition.bind(_assertThisInitialized(_this));
    _this.getContainerDOM = _this.getContainerDOM.bind(_assertThisInitialized(_this));
    _this.handleTargetChange = _this.handleTargetChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Affix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getInitPosition(undefined, true);
      var listenTarget = this.props.target();

      if (listenTarget) {
        addEventListener(listenTarget, 'resize', this.handleTargetChange);
        addEventListener(listenTarget, 'scroll', this.handleTargetChange); // listenTarget.addEventListener('resize', e=>this.handleTargetChange(e,'resize'))
        // listenTarget.addEventListener('scroll', e=>this.handleTargetChange(e,'scroll'))
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var listenTarget = this.props.target();

      if (listenTarget) {
        removeEventListener(listenTarget, 'resize', this.handleTargetChange);
        removeEventListener(listenTarget, 'scroll', this.handleTargetChange); // listenTarget.addEventListener('resize', e=>this.handleTargetChange(e,'resize'))
        // listenTarget.addEventListener('scroll', e=>this.handleTargetChange(e,'scroll'))
      }
    }
    /**
     * 获取container
     * @return {[type]} [description]
     */

  }, {
    key: "render",
    value: function render() {
      var _this$calculate = this.calculate(),
          fixStyle = _this$calculate.fixStyle,
          boxStyle = _this$calculate.boxStyle;

      var _this$props = this.props,
          offsetTop = _this$props.offsetTop,
          offsetBottom = _this$props.offsetBottom,
          horizontal = _this$props.horizontal,
          container = _this$props.container,
          target = _this$props.target,
          onChange = _this$props.onChange,
          onTargetChange = _this$props.onTargetChange,
          zIndex = _this$props.zIndex,
          canHidden = _this$props.canHidden,
          childrenRef = _this$props.childrenRef,
          others = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement("div", _extends({}, others, {
        className: classnames("".concat(prefix, "-affix-container"), this.props.className),
        id: this.state.containerId,
        style: boxStyle
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-affix-content"),
        style: fixStyle
      }, this.props.children));
    }
  }]);

  return Affix;
}(Component);

Affix.propTypes = propTypes;
Affix.defaultProps = defaultProps;
export default Affix;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-affix/src/Affix.js